<template lang="pug">

</template>

<script>
import { getTokenAndLocation } from '../../utils/index';
import { getForestStatus } from '../../api/ant-forest';

export default {
  created() {
    this.getBasic();
  },
  methods: {
    async getBasic() {
      const { token, cityCode } = await getTokenAndLocation();
      getForestStatus({
        token, cityCode,
      }).then((v) => {
        if (v && v.data) {
          const { targetUrl } = v.data;
          window.location.replace(targetUrl);
        }
      });
    },
  },
};
</script>
